import { Type } from "@sinclair/typebox";
import { measurementGeometrySchema, measurementPositionSchema } from "./map-measurements.js";
export const quoteNamedMeasurementSchema = Type.Object({
    mapMeasurementId: Type.Optional(Type.String({ minLength: 1, maxLength: 120 })),
    id: Type.String({ minLength: 1, maxLength: 120 }),
    name: Type.String({ minLength: 1, maxLength: 200 }),
    source: Type.Union([Type.Literal("manual"), Type.Literal("map"), Type.Literal("document")]),
    status: Type.Union([Type.Literal("indicative"), Type.Literal("verified")]),
    value: Type.String({ pattern: "^\\d+(?:\\.\\d{1,4})?$" }),
    unit: Type.String({ minLength: 1, maxLength: 40 }),
    geometry: Type.Optional(Type.Union([
        measurementGeometrySchema,
        Type.Object({
            type: Type.Literal("MultiPolygon"),
            coordinates: Type.Array(Type.Array(Type.Array(measurementPositionSchema, { minItems: 4, maxItems: 1001 }), {
                minItems: 1,
                maxItems: 100
            }), { maxItems: 100 })
        }, { additionalProperties: false })
    ])),
    note: Type.Optional(Type.String({ maxLength: 2000 }))
}, { additionalProperties: false });
import { quoteDocumentLayoutSchema } from "./quote-document.js";
export const quoteCompositionSchema = Type.Object({
    measurements: Type.Array(quoteNamedMeasurementSchema, { maxItems: 100 }),
    document: Type.Optional(quoteDocumentLayoutSchema)
}, { additionalProperties: false });
export const quoteLineCompositionProperties = {
    section: Type.Optional(Type.String({ maxLength: 200 })),
    detail: Type.Optional(Type.String({ maxLength: 12000 })),
    kind: Type.Optional(Type.Union([Type.Literal("work"), Type.Literal("note")])),
    alternative: Type.Optional(Type.String({ minLength: 1, maxLength: 200 })),
    measurement: Type.Optional(quoteNamedMeasurementSchema)
};
//# sourceMappingURL=quote-composition.js.map